"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Farad = void 0;
var uom_1 = require("uom");
exports.Farad = uom_1.UnitFormat.createUnitFormat("F", 0);
//# sourceMappingURL=electric-capacitance-format.js.map